import { ApplicationId } from "../schema/context";
import { Config, Context, Data, Effect, Layer, pipe, Schema } from "effect";
import Stripe from "stripe";
export class UnknownStripeApiError extends Schema.TaggedError()("@open-revenue/stripe/UnknownStripeApiError", {
    message: Schema.String,
    cause: Schema.Any
}) {
}
export class StripeApiError extends Data.TaggedError("@open-revenue/stripe/StripeApiError") {
    error;
    constructor(error){
        super(), this.error = error;
    }
    get message() {
        return this.error.message;
    }
    get errorType() {
        return this.error.type;
    }
    get errorMessage() {
        return this.error.message;
    }
    get errorStack() {
        return this.error.stack;
    }
    get errorString() {
        return this.error.toString();
    }
    get errorCause() {
        return this.error?.cause?.toString() || "Unknown cause";
    }
}
export class StripeApiAuthenticationError extends Schema.TaggedError()("@open-revenue/stripe/StripeApiAuthenticationError", {
    message: Schema.String
}) {
}
export class StripeApiConfigurationError extends Schema.TaggedError()("@open-revenue/stripe/StripeApiConfigurationError", {
    message: Schema.String,
    cause: Schema.optional(Schema.Any)
}) {
}
export class NoStripeKeyConfiguredError extends Schema.TaggedError()("@open-revenue/stripe/NoStripeKeyConfiguredError", {
    message: Schema.String,
    applicationId: ApplicationId,
    environment: Schema.optional(Schema.String)
}) {
}
export class StripeApiContext extends Context.Tag("@open-revenue/stripe/StripeApiContext")() {
    static layer = (config)=>pipe(Effect.succeed(config), Layer.effect(this));
    static layerConfig = (config)=>pipe(Config.unwrap(config), Layer.effect(this));
}
//
// TODO: Handle the different types of responses
//
export const make = (instance)=>Effect.sync(()=>(fn)=>Effect.async((cb)=>{
                fn(instance).then((res)=>cb(Effect.succeed(res))).catch((err)=>{
                    console.error("StripeApiError: ", err);
                    cb(err instanceof Stripe.errors.StripeError ? err.statusCode === 401 ? Effect.fail(new StripeApiAuthenticationError({
                        message: err.message || "There was an authentication error with the Stripe API"
                    })) : Effect.fail(new StripeApiError(err)) : Effect.fail(new UnknownStripeApiError({
                        message: "There was an unknown error with the Stripe API",
                        cause: err
                    })));
                });
            }));
export class StripeApiBaseClient extends Context.Tag("@open-revenue/stripe/StripeApiBaseClient")() {
    static make = make;
}
